<template lang="pug">
  table.sequence-of-numbers-table(
    :class="{\
        'sequence-of-numbers-table--small-border': sequenceOfNumbersTable.length > 6,\
        'sequence-of-numbers-table--disabled': isCountingCombinationsGameMode\
    }"
  )
    tbody
      tr.sequence-of-numbers__row(
        v-for='(row, rowIndex) in sequenceOfNumbersTable',
        :key='rowIndex'
      )
        td.sequence-of-numbers__cell(
          v-for='(num, numIndex) in row',
          :key='numIndex'
          :style="itemStyle"
        )
          .sequence-of-numbers-table__press-item(
            @mousedown="event => $emit('mousedown', event, num, rowIndex, numIndex)"
            @mousemove="event => $emit('mousemove', event)"
            :style="isColoredCells && getRandomCellColor()"
          )
            span(v-if="isNumbersMode")
              | {{ num }}
            sequence-of-numbers-table-icons(
              v-else
              :class-name="'cell-image'"
              :width="DEFAULT_TABLE_ICONS_SIZE"
              :height="DEFAULT_TABLE_ICONS_SIZE"
              :name="getImageName(num)"
              :fill="getCellColor(rowIndex, numIndex)"
            )
</template>

<script>
    import SequenceOfNumbersTableIcons from './SequenceOfNumbersTableIcons';

    const DEFAULT_TABLE_ICONS_SIZE = '50%';
    const CORRECT_ANSWER_ORANGE_COLOR = 'hsl(14, 100%, 64%)';
    const BLUE_COLOR = 'hsl(212, 100%, 56%)';
    const PURPLE_COLOR = 'hsl(274, 75% , 65%)';
    const PINK_COLOR = 'hsl(348, 100%, 70%)';
    const YELLOW_COLOR = 'hsl(38, 100%, 66%)';
    const BROWN_COLOR = 'hsl(30, 57%, 51%)';
    const LIGHT_BLUE_COLOR = 'hsl(191, 87%, 51%)';
    const ORANGE_COLOR = 'hsl(32, 100%, 50%)';
    const LIGHT_GREEN_COLOR = 'hsl(173, 89%, 42%)';
    const GREEN_COLOR = 'hsl(121, 38%, 58%)';
    const COLORS_FOR_TABLE_CELLS = [
        PINK_COLOR,
        PURPLE_COLOR,
        BLUE_COLOR,
        YELLOW_COLOR,
        BROWN_COLOR,
        LIGHT_BLUE_COLOR,
        ORANGE_COLOR,
        GREEN_COLOR,
        LIGHT_GREEN_COLOR,
    ];
    const CELLS_ICONS_NAMES = [
        'drop',
        'star',
        'circles',
        'circle',
        'smallCircle',
        'square',
        'rhombus',
        'squareRhombus',
        'emptySquare',
        'triangle',
    ];

    export default {
        props: {
            sequenceOfNumbersTable: {
                type: Array,
                default: () => [],
            },
            selectedLinesIndexes: {
                type: Array,
                default: () => [],
            },
            isColoredCells: {
                type: Boolean,
                default: false,
            },
            isNumbersMode: {
                type: Boolean,
                default: false,
            },
            isCountingCombinationsGameMode: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                DEFAULT_TABLE_ICONS_SIZE,
                itemSize: 0,
                itemLineHeight: 73,
                GREEN_COLOR,
            };
        },
        mounted() {
            window.addEventListener('resize', this.calculateSizeForSequenceOfNumbersTable);
            this.calculateSizeForSequenceOfNumbersTable();
        },
        methods: {
            getCellColor(rowIndex, numIndex) {
                let correctAnswer = false;
                if (this.selectedLinesIndexes?.length) {
                    for (let i = 0; i < this.selectedLinesIndexes.length; i++) {
                        if (
                            this.selectedLinesIndexes[i][0] === rowIndex &&
                            this.selectedLinesIndexes[i][1] === numIndex
                        ) {
                            correctAnswer = true;
                        }
                    }
                }
                return correctAnswer
                    ? CORRECT_ANSWER_ORANGE_COLOR
                    : this.cellColors[rowIndex * this.sequenceOfNumbersTable.length + numIndex];
            },
            getImageName(num) {
                return CELLS_ICONS_NAMES[num];
            },
            getRandomCellColor() {
                let randomIndexForCellColor = Math.floor(Math.random() * COLORS_FOR_TABLE_CELLS.length);
                if (this.isNumbersMode) {
                    return {
                        color: COLORS_FOR_TABLE_CELLS[randomIndexForCellColor],
                    };
                }
                return COLORS_FOR_TABLE_CELLS[randomIndexForCellColor];
            },
            calculateSizeForSequenceOfNumbersTable() {
                this.itemSize = 0;
                this.$nextTick(() => {
                    let sequenceOfNumbersTable = document.querySelector('.sequence-of-numbers-table');
                    let items = Array.from(document.querySelectorAll('.sequence-of-numbers__cell'));
                    const isSafari =
                        /constructor/i.test(window.HTMLElement) ||
                        (function(p) {
                            return p.toString() === '[object SafariRemoteNotification]';
                        })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
                    const newDimensionValue = value => (isSafari ? value * 0.88 : value);
                    let tempTableSize;
                    if (isSafari) {
                        const playBoxContainer = document.querySelector('.play-box');
                        tempTableSize = Math.min(playBoxContainer.clientWidth, playBoxContainer.clientHeight);
                    } else {
                        tempTableSize = Math.min(
                            sequenceOfNumbersTable.clientWidth,
                            sequenceOfNumbersTable.clientHeight
                        );
                    }
                    sequenceOfNumbersTable.style['height'] = newDimensionValue(tempTableSize) + 'px';
                    sequenceOfNumbersTable.style['width'] = newDimensionValue(tempTableSize) + 'px';
                    this.itemSize = newDimensionValue(items[0].clientWidth);
                });
            },
        },
        computed: {
            itemStyle() {
                return {
                    height: this.itemSize + 'px',
                    width: this.itemSize + 'px',
                    'font-size': this.itemLineHeight * this.fontCoefficient + 'px',
                    'line-height': this.itemLineHeight * this.fontCoefficient + 'px',
                };
            },
            fontCoefficient() {
                let coefficient = this.itemSize / this.itemLineHeight;
                if (this.sequenceOfNumbersTable.length > 3) {
                    coefficient *= this.sequenceOfNumbersTable.length > 3 ? 0.5 : 0.8;
                }
                return coefficient;
            },
            cellColors() {
                let randomColors = [];
                for (let i = 0; i < this.sequenceOfNumbersTable.length * this.sequenceOfNumbersTable.length; i++) {
                    randomColors.push(this.isColoredCells ? this.getRandomCellColor() : GREEN_COLOR);
                }
                return randomColors;
            },
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.calculateSizeForSequenceOfNumbersTable);
        },
        components: {
            SequenceOfNumbersTableIcons,
        },
    };
</script>

<style scoped lang="scss">
    .cell-image {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sequence-of-numbers-table {
        width: 100%;
        height: 100%;
        @include media($lg) {
            width: 90%;
            height: 90%;
        }
        border: 10px solid $x-color-white;
        border-collapse: collapse;
        border-spacing: 0;
        table-layout: fixed;
        box-sizing: border-box;
    }

    .sequence-of-numbers-table--disabled .sequence-of-numbers-table__press-item {
        pointer-events: none;
        cursor: auto;

        &:hover {
            background-color: transparent;
        }
    }

    .sequence-of-numbers-table--small-border,
    .sequence-of-numbers-table--small-border .sequence-of-numbers__cell {
        border: 4px solid $x-color-white;
    }

    .sequence-of-numbers__cell {
        text-align: center;
        vertical-align: middle;
        border: 5px solid $x-color-white;
        box-sizing: border-box;
        background: $x-color-white;
        font-size: 62px;
        line-height: 73px;
    }

    .sequence-of-numbers-table__press-item {
        width: 100%;
        height: 100%;
        margin: auto;
        display: flex;
        cursor: pointer;
        user-select: none;
        align-items: center;
        border-radius: $border-radius-10;
        justify-content: center;
        color: $hsl-color-green-58;
        background-color: $hsl-color-gray-97;
        transition: background-color 0.1s;

        @media (hover: hover) and (pointer: fine) {
            &:hover {
                color: $hsl-color-orange-64;
                background-color: $hsl-color-orange-95;
            }
        }
        &:active {
            color: $hsl-color-orange-64;
            background-color: $hsl-color-orange-95;
        }
    }

    .sequence-of-numbers-table__press-item_green {
        color: $x-color-white;
        background-color: $hsl-color-green-58;

        &:hover {
            background-color: $hsl-color-green-58;
        }
    }

    .sequence-of-numbers-table__selected-item_red {
        color: $hsl-color-orange-64;
        background-color: $hsl-color-orange-95;
    }

    .sequence-of-numbers-table__press-item_red {
        transition: none;
        color: $hsl-color-orange-64 !important;
    }

    .sequence-of-numbers-table--disabled .sequence-of-numbers-table__press-item {
        pointer-events: none;
        cursor: auto;
        &:hover {
            background-color: transparent;
        }
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
